import React from 'react';
import { get, find, has, isEqual, cloneDeep /*filter, isNil, head, isEmpty, isEqual, cloneDeep*/ } from 'lodash';

// local dependencies
import { memberEscalationCall as MemberEscalationCallView } from 'ui/views/widgets/memberEscalationCall';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { MemberEscalationCallService } from 'services/memberEscalationCall';

// import { resolveSecondaryOptionsResolver } from 'resolvers/resolveSecondaryOptions';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberEscalationCall } from 'ui/containers/MemberEscalationCall';
 *
 * // render
 * <MemberEscalationCall propName='propValue'/>
 */
export class MemberEscalationCall extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = this.composeStateFromProps();

        this._bind();
        this.memberEscalationCallService = new MemberEscalationCallService();
    }

    _bind() {

        this.onFormSubmit = this.onFormSubmit.bind( this );
        this.composeStateFromProps = this.composeStateFromProps.bind( this );
        this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
    }

    composeStateFromProps() {
        log.debug( 'MemberEscalationCall.composeStateFromProps()' );

        return {
            options: get( this.props, 'values.options', {} ),

            // fields: this.props.fields,

            values: get( this.props, 'values.state.values' ),

            // primaryType: get( this.props, `values.${ primaryTypeField.name }`, undefined ),
            // secondaryType: get( this.props, `values.${ secondaryTypeField.name }`, undefined ),
        };
    }

    handleFormChangeCallback( { values, field } ) {
        log.debug( 'MemberEscalation.handleFormChangeCallback()' );

        /*-------------------*/

       const fieldOption = find( this.props.fields, function( _field ) { return has( _field.config, 'secondaryOptions' ); } );

       if( isEqual( field.name, fieldOption.name ) ) {

            const optionsList = get( this.props, `values.options.${ fieldOption.options }`, {} );

            const selectedvalueForField = values[ field.name ];

            const secondaryOptionList = find( optionsList, { value: selectedvalueForField } );

            if( secondaryOptionList ) {

                const options = cloneDeep( this.state.options );
                options[ fieldOption.config.secondaryOptions ] = secondaryOptionList.options;
                values[ fieldOption.config.secondaryOptions ] = '';
                this.setState( { options, values } );

            }
       }

        /*-------------------*/
    }

    /**
     * action executed when user clicks on form submit
     */
    async onFormSubmit ( formData ) {
        log.debug( 'MemberEscalationCall.onFormSubmit()' );

        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.memberEscalationCallService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberEscalationCallView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }
                onChangeCallBack={ this.handleFormChangeCallback }
            />
        );
    }
}

// set display name
MemberEscalationCall.displayName = 'MemberEscalationCall';

// set default props
MemberEscalationCall.defaultProps = {};

// prop types
MemberEscalationCall.propTypes = {};
